import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, RsModalConfig } from '@revspringinc/rs-shared';
import { ShoppingActivityType } from '../../main/shopping-activity-type';

@Component({
    selector: 'procedures-not-performed',
    templateUrl: './procedures-not-performed.component.html',
    standalone: false
})
export class ProceduresNotPerformedModal {
    public static modalName = 'ProceduresNotPerformedModal';
    @ViewChild('modal', { static: true }) public modal;
    public title: string;
    public subtitle: string;
    public procData: any;

    public modalConfig = {
        activityType: ShoppingActivityType.NotPerformedProcedures,
        name: 'ProceduresNotPerformedModal',
        title: '',
        subtitle: '',
        maxWidth: '700px',
        maxHeight: '500px',
        bodyClass: 'gray-bck px-0',
        footer: {
            hidden: false,
            close: 'Close',
        },
    } as RsModalConfig;

    constructor(
        private readonly modalService: ModalService,
        private readonly translateService: TranslateService,
    ) {}

    public cancel(target?: any) {
        this.modal.hide();
    }

    public show(payload: any): void {
        this.procData = payload?.config;
        this.setTranslation(this.procData);
    }


    private setTranslation(siteConfig: any) {
        Object.keys(siteConfig.language).forEach((lang) =>
            this.translateService.setTranslation(lang, siteConfig.language[lang], true),
        );

        this.modalConfig.title = this.translateService.instant(siteConfig.language.en_US['unsupported-procedures-title']);
        this.modalConfig.subtitle = this.translateService.instant(siteConfig.language.en_US['unsupported-procedures-subtitle']);
    }
}
